import { call, put } from 'redux-saga/effects';
import _ from 'lodash';
import {
  saveRegistrationParams,
  saveUserName,
} from '../../services/auth';
import { saveUserProfile } from '../actions';
import { claimRegistrationFlow } from '../../common/lib/registrationFlowSession';
import {
  getCallbackParams,
  resolvePostEmailVerificationRoute,
  shouldSaveRegistrationParams,
} from '../../common/lib/postEmailVerificationRouting';

export const createNavigateAfterEmailVerified = (api) => function* navigateAfterEmailVerified(push) {
  claimRegistrationFlow();

  const userData = yield call(api.fetchProfile);
  const userDataParsed = _.get(userData, 'data.data.attributes', false);
  const { firstName, lastName } = userDataParsed || {};

  if (firstName || lastName) {
    saveUserName({
      firstName,
      lastName, 
    });
  }

  if (userDataParsed) {
    yield put(saveUserProfile({ userData: userDataParsed }));
  }

  const { callbackUri, clientId } = getCallbackParams();
  const route = resolvePostEmailVerificationRoute(userDataParsed, {
    callbackUri,
    clientId, 
  });

  if (route.type === 'push') {
    if (shouldSaveRegistrationParams(route.path)) {
      saveRegistrationParams({
        clientId,
        callbackUri, 
      });
    }
    push(route.path);
  }
};
